// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import DateUtils from '../../utils/DateUtils';
import ApiConstants from '../../constants/ApiConstants';

export default class AbstractOrderModeSetting extends ApiObject {

  orderPaymentMethodsAllowed = ApiConstants.OrderPaymentMethodsAllowed;

  /**
   * true if the on-site order mode is enabled.
   *
   * @type Boolean
   */
	enabled: boolean = false;

  /**
   * The max time ahead to order.
   * Mostly in days.
   */
  maxTimeAhead: MsTimestamp = 0;

  /**
   * The minimum order total required for a delivery.
   */
  minimumPrice: Price = 0;

  irlPaymentAllowed: bool = false;

  paymentMethodsAllowed: number = 0; // long

  getMaxTimeAheadAsDays(): Days {
    return DateUtils.millisecondsToDays(this.maxTimeAhead);
  }

  setMaxTimeAheadWithDays(days: Days) {
    this.maxTimeAhead = DateUtils.daysToMilliseconds(days);
  }

  // -- features
  havePaymentMethodAllowed(paymentMethodsAllowed: number): boolean {
    return (paymentMethodsAllowed & this.paymentMethodsAllowed) !== 0;
  }

  havePaymentMethodAllowedIrl(): boolean {
    return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.IRL);
  }

  havePaymentMethodAllowedCreditCard(): boolean {
    return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.CREDIT_CARD);
  }

  havePaymentMethodAllowedTRD(): boolean {
    return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.TRD);
  }

  havePaymentMethodAllowedUserAccount(): boolean {
    return this.havePaymentMethodAllowed(this.orderPaymentMethodsAllowed.USER_ACCOUNT);
  }

}
